import { useEffect } from 'react';
import ActiveUserReportPage from './report';
import { useQuery } from '@apollo/client';
import { useDashboardStore } from '../../store/useDashboardStore';
import { GetActiveUsersQuery, GetActiveUsersQueryVariables } from '@/graphql/generated/graphql';
import { GET_ACTIVE_USERS } from '@/graphql/queries/report/ga-interactions';
import { useAdminStore } from '@/pages/admin/store/useAdmin.store';

export default function FeatureUsage() {
  const { page } = useAdminStore();
  const { type, getDateRange, totalActiveUsers, updateTotalUsers, updateTotalActiveUsers, getPeriod, schoolsIds } =
    useDashboardStore();
  const { data, loading } = useQuery<GetActiveUsersQuery, GetActiveUsersQueryVariables>(GET_ACTIVE_USERS, {
    variables: {
      startDate: getDateRange()?.startDate,
      endDate: getDateRange()?.endDate,
      period: getPeriod(),
      schoolsIds,
    },
  });

  useEffect(() => {
    updateTotalUsers(data?.getActiveUsers?.totalUsers || 0);
    updateTotalActiveUsers(data?.getActiveUsers?.totalActiveUsers || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center">
          <div className="h-64 w-full animate-pulse rounded-sm bg-gray-300"></div>
        </div>
      );
    }

    if (data?.getActiveUsers?.totalActiveUsers === 0) {
      return (
        <div className="flex items-center justify-center">
          {/* //Empty state of a doughnut chart */}
          <div className="flex flex-col items-center justify-center">
            <p className="text-sh-xs text-gray-500">No data available</p>
          </div>
        </div>
      );
    }
    return <ActiveUserReportPage data={data} />;
  };

  return (
    <>
      <div className="flex justify-between border-b-2 border-[#ECECEC] px-11 py-6 ">
        <div>
          <p className=" text-sh-xs font-bold capitalize">
            {page?.dashboard?.chartsTitles?.dailyUsers?.replace('${type}', type) || type + ' Users'}
          </p>
          <p className="text-sh-36-48 text-[#0B1354]">{totalActiveUsers || '-'}</p>
          <p className=" text-[#4F4F4F]">Total users</p>
        </div>
      </div>
      <div className=" px-sh-30 py-sh-15">{renderContent()}</div>
    </>
  );
}
